import { Injectable } from '@angular/core';
import { DataService } from '../../architecture/data.service';
import { Result } from '../../architecture/envelopes';

@Injectable({ providedIn: 'root' })
export class ProcessService {
    constructor(private dataService: DataService) {}

    public initProcess(credit: any) {            
        return this.dataService.post<Result<any>>('process', credit);
    }
}
